import { executeRequest, JFSRequest } from '@jfs/network'
import {
  dateFormatter,
  DateFormatTypes,
  fromDateTime,
  getAcceptableStatus,
  isSuccessResponse,
  toDateTime,
} from '../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const parser = (dataList: any, count: number) => {
  let parsedList: any[] = []
  dataList?.map((data) => {
    parsedList.push({
      applicationId: data?.applicationId,
      auditType: data?.auditType,
      applicationStatus: data?.applicationStatus === 'Pending' ? 'Pending For Approval' : data?.applicationStatus,
      assignee: data?.assignee,
      authorisedSignatory: data?.authorisedSignatory,
      beneficialOwnerDetails: data?.beneficialOwnerDetails,
      businessProfile: data?.businessProfile,
      comments: data?.comments,
      createdAt: dateFormatter(data?.createdAt, DateFormatTypes.TIME_STAMP),
      createdBy: data?.createdBy,
      directorDetails: data?.directorDetails,
      identificationNumber: data?.identificationNumber,
      uploadId: data?.uploadId,
      makerComments: data?.makerComments ?? 'N/A',
      action: data?.applicationStatus === 'Error' ? '_retry' : '',
    })
  })
  return { list: parsedList, count: count }
}

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return parser(data?.data, data?.count)
}

const getAadharRedactionGlobalCheckerListReq = (
  selectedDateInfo: any,
  pagination: any,
  applicationStatus: any,
  tokens: any,
  searchBy?: string,
  searchKey?: string,
) => {
  console.log(
    'selectedDateInfo: ',
    JSON.parse(JSON.stringify(selectedDateInfo)),
    JSON.parse(JSON.stringify(pagination)),
  )
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getGlobalCheckerList),
    method: 'POST',
    cache: false,
    body: {
      configParams: {
        page: searchBy && searchBy?.length > 0 && searchKey?.length > 0 ? 1 : pagination.number,
        recordCount: 10,
      },
      inputFilters: {
        endDateTime:
          selectedDateInfo.toDate !== new Date(Date.now())
            ? toDateTime(new Date(Date.now()))
            : toDateTime(selectedDateInfo.toDate),
        startDateTime: fromDateTime(selectedDateInfo.fromDate),
        ...(applicationStatus.length > 0 &&
          !applicationStatus?.includes('ALL') && {
            status: getAcceptableStatus(applicationStatus),
          }),
        ...(searchBy?.length > 0 && searchKey?.length > 0 && { [searchBy]: searchKey }),
      },
      processDefinitionKeyType: 'AADHAR_REDACTION',
    },
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getAadharRedactionGlobalCheckerListReq }
